import { properties } from "../utils/properties";

export const getService = async (url, token) => {
  try {
    const response = await fetch(`${properties.cdnURL}${url}`, {
      async: true,
      crossDomain: true,
      method: "GET",
      headers: {
        Pragma: "no-cache",
        "cache-control": "no-cache",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "An error occurred");
    }

    return await response.json();
  } catch (error) {
    console.error("Service call failed:", error);
    throw error;
  }
};

export const postService = async (url, requestBody) => {
  try {
    let data = await fetch(`${properties.cdnURL}${url}`, {
      async: true,
      crossDomain: true,
      method: "POST",
      headers: {
        Pragma: "no-cache",
        "cache-control": "no-cache",
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },

      body: new URLSearchParams(requestBody).toString(),
    });
    data = await data.json();
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
